import React from "react";
import Button from "./Button";
import { CTA_URL, DOSSIER_URL, LANDING_COPY } from "../constants";

const FinalCta: React.FC = () => {
  const { finalCta } = LANDING_COPY;

  return (
    <section id="cierre" className="bg-black py-20 md:py-24">
      <div className="mx-auto w-full max-w-6xl px-4 sm:px-6 lg:px-8">
        <div className="animate-soft-scale rounded-2xl border border-brand-pink/30 bg-gradient-to-br from-zinc-950 via-black to-zinc-900 px-6 py-12 text-center md:px-12">
          <h2 className="animate-fade-in-up font-display text-3xl font-semibold leading-tight text-white md:text-5xl">
            {finalCta.title}
          </h2>
          <p className="animate-fade-in-up delay-100 mx-auto mt-7 max-w-4xl text-lg leading-relaxed text-zinc-300">
            {finalCta.text}
          </p>

          <div className="animate-fade-in-up delay-200 mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row">
            <Button href={CTA_URL}>{finalCta.primaryCta}</Button>
            <Button href={DOSSIER_URL} variant="secondary">
              {finalCta.secondaryCta}
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FinalCta;
